import type { ReactNode } from 'react';
import { HelmetProvider as ReactHelmetProvider } from 'react-helmet-async';

/**
 * HelmetProvider — thin re-export of `react-helmet-async`'s provider with
 * a children-only API so the webapp's tree composes the same way as the
 * other providers in `src/app/providers/`.
 */
export function HelmetProvider({ children }: { children: ReactNode }) {
  return <ReactHelmetProvider>{children}</ReactHelmetProvider>;
}

export default HelmetProvider;
